"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFuturesReverseParams = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../interface");
const FutureTradeProcessor_1 = require("./FutureTradeProcessor");
const CustomAssetsProvider_1 = require("../../../component/CustomAssetsProvider");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const errors_1 = require("../../../interface/errors");
const FutureAPI_1 = require("../../../apis/FutureAPI");
const FutureIndexProvider_1 = require("../../../component/FutureIndexProvider");
const calculateReverseQty = (curPrice, position, balance) => {
    const price = new trade_utils_lib_1.SafeDecimal(curPrice);
    const leverage = new trade_utils_lib_1.SafeDecimal(position.leverage);
    const positionABS = new trade_utils_lib_1.SafeDecimal(position.positionQuantity).abs();
    // 预期平仓释放出来的保证金
    const avaMargin = new trade_utils_lib_1.SafeDecimal(balance.availableMargin);
    const esFreeMargin = positionABS.mul(price).div(leverage);
    // 预期平仓后的总保证金 free + debts + 总盈亏 - (总占用 - 平仓后释放出的保证金)
    // 能买到的仓位数量qty = esTotalMargin * leverage / curPrice * 0.95冗余
    // 最大交易的仓位数 maxQty = 仓位数量的绝对值positionABS * 2
    // 最小交易的仓位数 minQty = positionABS
    // if (qty > maxQty) {
    //     return maxQty;
    // } else if (qty <= 0) {
    //     return minQty;
    // } else {
    //     return qty
    // }
    const esTotalMargin = avaMargin.add(esFreeMargin);
    const marginCanBuy = esTotalMargin.mul(leverage).div(price).mul(0.95);
    const qty = marginCanBuy.add(positionABS);
    const maxQty = positionABS.mul(2);
    const minQty = positionABS;
    if (qty.greaterThan(maxQty)) {
        return maxQty;
    }
    else if (qty.lessThanOrEqualTo(0)) {
        return minQty;
    }
    else {
        return qty;
    }
};
const useFuturesReverseParams = (props) => {
    const { isFocused } = props;
    const balance = (0, CustomAssetsProvider_1.useCustomBalance)(trade_utils_lib_1.AccountTradeType.trader, "USDT", isFocused).balance;
    const queryReverseRequest = (0, react_1.useCallback)((position) => {
        const symbolInfo = (0, trade_utils_lib_1.getTradeDependencyInstance)().getSymbolInfo(position.symbol);
        if (!balance) {
            return (0, rxjs_1.throwError)(errors_1.TRADE_NO_AVAILABLE);
        }
        if (!symbolInfo) {
            return (0, rxjs_1.throwError)(errors_1.TRADE_SYMBOL_INFO_NONE);
        }
        const orderSide = new trade_utils_lib_1.SafeDecimal(position === null || position === void 0 ? void 0 : position.positionQuantity).greaterThanOrEqualTo(0)
            ? interface_1.CustomOrderSide.SELL
            : interface_1.CustomOrderSide.BUY;
        return (0, FutureIndexProvider_1.queryFuturesIndexOnce)(symbolInfo.symbol).pipe((0, operators_1.map)((index) => {
            const curPrice = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(index.mark_price, symbolInfo.precision);
            const qty = calculateReverseQty(curPrice, position, balance);
            const request = {
                accountType: FutureTradeProcessor_1.FutureAccountType,
                symbol: position.symbol,
                type: interface_1.CustomOrderType.MARKET_QTY,
                side: orderSide,
                amount: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(qty, symbolInfo.amount),
                confirmed_sensitive: true,
            };
            return request;
        }));
    }, [balance]);
    const reverseWithRequest = (0, react_1.useCallback)((req) => {
        return (0, FutureAPI_1.postCustomOrder)(req).pipe((0, operators_1.tap)(() => {
            setTimeout(() => {
                (0, CustomAssetsProvider_1.refreshAccountDetail)();
            }, 500);
        }), (0, operators_1.catchError)((error) => {
            return (0, rxjs_1.throwError)((0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(error));
        }));
    }, []);
    const reverseAction = (0, react_1.useCallback)((position) => {
        return queryReverseRequest(position).pipe((0, operators_1.mergeMap)((req) => {
            return reverseWithRequest(req);
        }));
    }, [queryReverseRequest, reverseWithRequest]);
    return { reverseAction, queryReverseRequest, reverseWithRequest };
};
exports.useFuturesReverseParams = useFuturesReverseParams;
